export interface IPaymentSearchByMerchantReferenceCriteria {
    
    merchantReferenceCodes:Array<string>
}


export class PaymentSearchByMerchantReferenceCriteria implements IPaymentSearchByMerchantReferenceCriteria{

    merchantReferenceCodes:Array<string>
    
}